module.exports = __webpack_public_path__ + "img/1.612eb29b.jpg";